import Button from '@/design_system/Button';
import IconTrash from '@/icons/Trash.svg';

export const DeleteButtonIconOnly = ({
  ariaLabel,
  size = 'small',
  onClick,
}: {
  ariaLabel: string;
  size?: 'small' | 'medium' | 'large';
  onClick: () => void;
}) => {
  return (
    <Button variant="secondary-danger" size={size} iconOnly ariaLabel={ariaLabel} onPress={onClick}>
      <IconTrash />
    </Button>
  );
};
